/**
 * Free 6-month warranty gift sync (fast path):
 * On main-item remove (qty 0), delete main + linked gifts in ONE /cart/update.js.
 * Gift qty cannot be increased/decreased manually.
 */
(function () {
  if (window.ExtendWarrantyCart && window.ExtendWarrantyCart.__v11) return;

  var IS_GIFT = '_is_gift';
  var GIFT_FOR = '_gift_for';
  var GIFT_LABEL = '_赠品';
  var cachedCart = null;
  var selfRemoving = false;
  var cleaning = false;
  var scheduleTimer = null;
  var lockTimer = null;
  var originalChangeItem = null;
  var originalGetCart = null;

  function propsOf(item) {
    return (item && item.properties) || {};
  }
  function isGift(item) {
    var props = propsOf(item);
    if (String(props[IS_GIFT] || '') === 'true') return true;
    // Fallback if theme stripped _is_gift but left Chinese gift marker
    if (props[GIFT_LABEL] != null && String(props[GIFT_LABEL]) !== '') return true;
    return false;
  }
  function giftForId(item) {
    var n = parseInt(String(propsOf(item)[GIFT_FOR] || ''), 10);
    return isNaN(n) ? null : n;
  }

  /**
   * theme.js buildCart deletes keys starting with "_" on the same cart object.
   * Always store a deep copy of properties so gift markers survive.
   */
  function cloneCart(cart) {
    if (!cart) return null;
    var items = (cart.items || []).map(function (item) {
      var copy = {};
      for (var k in item) {
        if (Object.prototype.hasOwnProperty.call(item, k)) copy[k] = item[k];
      }
      copy.properties = {};
      if (item.properties) {
        for (var pk in item.properties) {
          if (Object.prototype.hasOwnProperty.call(item.properties, pk)) {
            copy.properties[pk] = item.properties[pk];
          }
        }
      }
      return copy;
    });
    return {
      token: cart.token,
      note: cart.note,
      attributes: cart.attributes,
      total_price: cart.total_price,
      total_weight: cart.total_weight,
      item_count: cart.item_count,
      items: items,
      requires_shipping: cart.requires_shipping,
      currency: cart.currency
    };
  }

  function cacheCart(cart) {
    if (cart && cart.items) {
      cachedCart = cloneCart(cart);
    }
    return cart;
  }

  function findItemByLine(line) {
    var items = (cachedCart && cachedCart.items) || [];
    var idx = parseInt(line, 10) - 1;
    return idx >= 0 && items[idx] ? items[idx] : null;
  }

  function findItemByKey(key) {
    if (!key) return null;
    var items = (cachedCart && cachedCart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].key === key) return items[i];
    }
    return null;
  }

  function findOrphans(items) {
    var mainIds = {};
    (items || []).forEach(function (it) {
      if (!isGift(it) && it.variant_id != null) mainIds[String(it.variant_id)] = true;
    });
    return (items || []).filter(function (it) {
      if (!isGift(it)) return false;
      var gf = giftForId(it);
      return gf == null || !mainIds[String(gf)];
    });
  }

  function giftsForVariant(items, variantId) {
    var vid = String(variantId);
    return (items || []).filter(function (it) {
      return isGift(it) && String(giftForId(it)) === vid;
    });
  }

  function injectLockStyles() {
    if (document.getElementById('ew-gift-qty-lock-style')) return;
    var style = document.createElement('style');
    style.id = 'ew-gift-qty-lock-style';
    style.textContent =
      /* Keep +/- visible but disabled for gifts */
      '.ajaxcart__qty[data-ew-gift-locked="1"] .ajaxcart__qty-adjust{' +
      'pointer-events:none;cursor:not-allowed;opacity:0.4;}' +
      '.ajaxcart__qty[data-ew-gift-locked="1"] .ajaxcart__qty-num{' +
      'pointer-events:none;cursor:default;}' +
      '.cart__product-qty[data-ew-gift-locked="1"]{pointer-events:none;background:#f5f5f5;}' +
      /* Gift lines: no jump to gift product page */
      '.ajaxcart__product[data-ew-gift="1"] a.ajaxcart__product-image,' +
      '.ajaxcart__product[data-ew-gift="1"] a.ajaxcart__product-name,' +
      '.ajaxcart__product[data-ew-gift="1"] .grid__item.one-quarter a{' +
      'pointer-events:none!important;cursor:default!important;}' +
      '.ajaxcart__product[data-ew-gift="1"] a.ajaxcart__product-image:hover,' +
      '.ajaxcart__product[data-ew-gift="1"] a.ajaxcart__product-name:hover{text-decoration:none;}';
    document.head.appendChild(style);
  }

  /** Lock gift qty UI + disable product page links on gift lines. */
  function lockGiftQtyControls() {
    injectLockStyles();
    var items = (cachedCart && cachedCart.items) || [];
    items.forEach(function (item) {
      if (!isGift(item) || !item.key) return;

      var inputs = document.querySelectorAll(
        '.ajaxcart__qty-num[data-id="' + item.key + '"], .cart__product-qty[data-id="' + item.key + '"]'
      );
      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        input.readOnly = true;
        input.setAttribute('data-ew-gift-locked', '1');
        input.setAttribute('aria-readonly', 'true');
        input.tabIndex = -1;

        var qtyWrap = input.closest('.ajaxcart__qty');
        if (qtyWrap) {
          qtyWrap.setAttribute('data-ew-gift-locked', '1');
          var btns = qtyWrap.querySelectorAll('.ajaxcart__qty-adjust');
          for (var b = 0; b < btns.length; b++) {
            btns[b].disabled = true;
            btns[b].setAttribute('aria-disabled', 'true');
            btns[b].tabIndex = -1;
          }
        }

        // Drawer row: mark gift + strip product links (image / title)
        var product = input.closest('.ajaxcart__product');
        if (product) {
          product.setAttribute('data-ew-gift', '1');
          var links = product.querySelectorAll(
            'a.ajaxcart__product-image, a.ajaxcart__product-name, .grid__item.one-quarter a'
          );
          for (var L = 0; L < links.length; L++) {
            var a = links[L];
            if (a.getAttribute('data-ew-link-disabled') === '1') continue;
            a.setAttribute('data-ew-link-disabled', '1');
            a.setAttribute('data-ew-original-href', a.getAttribute('href') || '');
            a.removeAttribute('href');
            a.setAttribute('role', 'presentation');
            a.style.pointerEvents = 'none';
            a.style.cursor = 'default';
          }
        }
      }
    });
  }

  function scheduleLockGiftQty() {
    if (lockTimer) clearTimeout(lockTimer);
    lockTimer = setTimeout(function () {
      lockTimer = null;
      lockGiftQtyControls();
    }, 0);
  }

  function hideCartLineByKey(key) {
    if (!key) return;
    var nodes = document.querySelectorAll(
      '.ajaxcart__qty-num[data-id="' + key + '"], .ajaxcart__qty-adjust[data-id="' + key + '"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      var product = nodes[i].closest('.ajaxcart__product');
      if (!product) continue;
      product.classList.add('is-removed');
      var row = product.querySelector('.ajaxcart__row');
      if (row) row.classList.add('is-loading');
    }
  }

  function postUpdates(updates) {
    selfRemoving = true;
    cleaning = true;
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/update failed: ' + res.status);
        return res.json();
      })
      .then(function (cart) {
        cacheCart(cart);
        scheduleLockGiftQty();
        return cart;
      })
      .finally(function () {
        selfRemoving = false;
        cleaning = false;
      });
  }

  function refreshCartFromServer() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart.js failed');
        return r.json();
      })
      .then(function (cart) {
        cacheCart(cart);
        scheduleLockGiftQty();
        return cart;
      });
  }

  /** Reject manual qty change/remove on gift; refresh drawer to reset UI. */
  function rejectGiftQtyChange(callback) {
    cleaning = false;
    function done(cart) {
      cacheCart(cart);
      if (typeof callback === 'function') callback(cart);
      scheduleLockGiftQty();
    }
    if (originalGetCart) {
      originalGetCart.call(window.ShopifyAPI, done);
      return;
    }
    refreshCartFromServer().then(done);
  }

  /**
   * qty=0 fast path: one request removes main + its gifts together.
   * Gift lines themselves cannot be qty-adjusted or removed alone.
   */
  function removeLineWithLinkedGifts(line, callback) {
    var lineNum = parseInt(line, 10);
    cleaning = true;

    function resolveKeyFromDom() {
      var row = document.querySelector('.ajaxcart__row[data-line="' + lineNum + '"]');
      if (!row) return null;
      var el = row.querySelector('[data-id]');
      return el ? el.getAttribute('data-id') : null;
    }

    function apply(cart) {
      var items = (cart && cart.items) || [];
      var keyFromDom = resolveKeyFromDom();
      var target = null;

      if (keyFromDom) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].key === keyFromDom) {
            target = items[i];
            break;
          }
        }
      }
      if (!target && lineNum > 0 && items[lineNum - 1]) {
        target = items[lineNum - 1];
      }
      if (!target || !target.key) {
        cleaning = false;
        return originalChangeItem.call(window.ShopifyAPI, line, 0, function (c) {
          cacheCart(c);
          syncFromCart(c).then(function (finalCart) {
            if (typeof callback === 'function') callback(finalCart || c);
            scheduleLockGiftQty();
          });
        });
      }

      // Gift qty/remove is locked — only removed with main product
      if (isGift(target)) {
        return rejectGiftQtyChange(callback);
      }

      var updates = {};
      updates[target.key] = 0;
      hideCartLineByKey(target.key);

      giftsForVariant(items, target.variant_id).forEach(function (gift) {
        updates[gift.key] = 0;
        hideCartLineByKey(gift.key);
      });

      return postUpdates(updates)
        .then(function (newCart) {
          if (typeof callback === 'function') callback(newCart);
          scheduleLockGiftQty();
        })
        .catch(function (err) {
          console.warn('[ExtendWarrantyCart] fast remove failed, fallback', err);
          originalChangeItem.call(window.ShopifyAPI, line, 0, function (c) {
            cacheCart(c);
            syncFromCart(c).then(function (finalCart) {
              if (typeof callback === 'function') callback(finalCart || c);
              scheduleLockGiftQty();
            });
          });
        });
    }

    if (cachedCart && cachedCart.items) {
      var previewItems = cachedCart.items;
      var previewKey = resolveKeyFromDom();
      var preview = null;
      if (previewKey) {
        for (var p = 0; p < previewItems.length; p++) {
          if (previewItems[p].key === previewKey) {
            preview = previewItems[p];
            break;
          }
        }
      }
      if (!preview && lineNum > 0) preview = previewItems[lineNum - 1];
      if (preview && !isGift(preview)) {
        hideCartLineByKey(preview.key);
        giftsForVariant(previewItems, preview.variant_id).forEach(function (g) {
          hideCartLineByKey(g.key);
        });
      }
    }

    if (cachedCart && cachedCart.items && cachedCart.items.length) {
      return apply(cachedCart);
    }
    return refreshCartFromServer().then(apply).catch(function () {
      cleaning = false;
      originalChangeItem.call(window.ShopifyAPI, line, 0, callback);
    });
  }

  function syncFromCart(cart) {
    cacheCart(cart);
    scheduleLockGiftQty();

    var orphans = findOrphans((cart && cart.items) || []);
    if (orphans.length) {
      orphans.forEach(function (it) {
        hideCartLineByKey(it.key);
      });
      var orphanUpdates = {};
      orphans.forEach(function (it) {
        if (it.key) orphanUpdates[it.key] = 0;
      });
      return postUpdates(orphanUpdates).then(function (nextCart) {
        return syncGiftQuantities(nextCart || cart);
      });
    }

    return syncGiftQuantities(cart);
  }

  /**
   * Keep each gift qty equal to its linked main variant qty.
   */
  function syncGiftQuantities(cart) {
    var items = (cart && cart.items) || [];
    var mainQtyByVariant = {};
    items.forEach(function (it) {
      if (!isGift(it) && it.variant_id != null) {
        var id = String(it.variant_id);
        mainQtyByVariant[id] = (mainQtyByVariant[id] || 0) + (parseInt(it.quantity, 10) || 0);
      }
    });

    var updates = {};
    var changed = false;
    items.forEach(function (it) {
      if (!isGift(it) || !it.key) return;
      var gf = giftForId(it);
      if (gf == null) return;
      var want = mainQtyByVariant[String(gf)];
      if (want == null) return;
      if (parseInt(it.quantity, 10) !== want) {
        updates[it.key] = want;
        changed = true;
      }
    });

    if (!changed) {
      scheduleLockGiftQty();
      return Promise.resolve(cart);
    }
    return postUpdates(updates);
  }

  /**
   * qty>0: update main + linked gifts together so gift qty follows main.
   */
  function changeLineWithLinkedGifts(line, quantity, callback) {
    var qty = parseInt(quantity, 10);
    var lineNum = parseInt(line, 10);
    if (isNaN(qty) || qty < 1) {
      return removeLineWithLinkedGifts(line, callback);
    }

    function resolveKeyFromDom() {
      var row = document.querySelector('.ajaxcart__row[data-line="' + lineNum + '"]');
      if (!row) return null;
      var el = row.querySelector('[data-id]');
      return el ? el.getAttribute('data-id') : null;
    }

    function apply(cart) {
      var items = (cart && cart.items) || [];
      var keyFromDom = resolveKeyFromDom();
      var target = null;

      if (keyFromDom) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].key === keyFromDom) {
            target = items[i];
            break;
          }
        }
      }
      if (!target && lineNum > 0 && items[lineNum - 1]) {
        target = items[lineNum - 1];
      }
      if (!target || !target.key || isGift(target)) {
        return originalChangeItem.call(window.ShopifyAPI, line, qty, function (c) {
          cacheCart(c);
          syncFromCart(c).then(function (finalCart) {
            if (typeof callback === 'function') callback(finalCart || c);
            scheduleLockGiftQty();
          });
        });
      }

      var updates = {};
      updates[target.key] = qty;

      giftsForVariant(items, target.variant_id).forEach(function (gift) {
        updates[gift.key] = qty;
        // Optimistic UI for gift qty display
        var giftInput = document.querySelector('.ajaxcart__qty-num[data-id="' + gift.key + '"]');
        if (giftInput) giftInput.value = String(qty);
        var giftSpan = document.querySelector('.cart__product-qty--gift[data-id="' + gift.key + '"]');
        if (giftSpan) giftSpan.textContent = String(qty);
        var giftHidden = document.querySelector('input[type="hidden"][data-id="' + gift.key + '"]');
        if (giftHidden) giftHidden.value = String(qty);
      });

      return postUpdates(updates)
        .then(function (newCart) {
          if (typeof callback === 'function') callback(newCart);
          scheduleLockGiftQty();
        })
        .catch(function (err) {
          console.warn('[ExtendWarrantyCart] qty sync failed, fallback', err);
          originalChangeItem.call(window.ShopifyAPI, line, qty, function (c) {
            cacheCart(c);
            syncFromCart(c).then(function (finalCart) {
              if (typeof callback === 'function') callback(finalCart || c);
              scheduleLockGiftQty();
            });
          });
        });
    }

    if (cachedCart && cachedCart.items && cachedCart.items.length) {
      return apply(cachedCart);
    }
    return refreshCartFromServer().then(apply).catch(function () {
      originalChangeItem.call(window.ShopifyAPI, line, qty, callback);
    });
  }

  function sync() {
    return refreshCartFromServer()
      .then(function (cart) {
        return syncFromCart(cart);
      })
      .catch(function (e) {
        console.warn('[ExtendWarrantyCart] sync error', e);
      });
  }

  function schedule(delay) {
    if (scheduleTimer) clearTimeout(scheduleTimer);
    scheduleTimer = setTimeout(function () {
      scheduleTimer = null;
      sync();
    }, delay == null ? 30 : delay);
  }

  function hasOrphanRisk() {
    if (cleaning) return true;
    if (!cachedCart || !cachedCart.items) return false;
    return findOrphans(cachedCart.items).length > 0;
  }

  function bindCheckoutGuard() {
    function goCheckout(el) {
      var href = '/checkout';
      if (el && el.tagName === 'A' && el.getAttribute('href')) {
        href = el.getAttribute('href');
      }
      window.location.href = href;
    }

    function ensureCleanThenCheckout(el) {
      cleaning = true;
      sync()
        .then(function () {
          goCheckout(el);
        })
        .catch(function () {
          goCheckout(el);
        });
    }

    document.addEventListener(
      'click',
      function (e) {
        var el = e.target.closest(
          'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href*="/checkout"]'
        );
        if (!el) return;
        if (!hasOrphanRisk() && !cleaning) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        ensureCleanThenCheckout(el);
      },
      true
    );

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.classList || !form.classList.contains('ajaxcart')) return;
        if (!hasOrphanRisk() && !cleaning) return;
        e.preventDefault();
        e.stopPropagation();
        ensureCleanThenCheckout(null);
      },
      true
    );
  }

  /** Block +/- / qty input / product links on gift lines. */
  function bindGiftQtyUiGuard() {
    document.addEventListener(
      'click',
      function (e) {
        // Gift product image / title must not navigate
        var giftProduct = e.target.closest('.ajaxcart__product[data-ew-gift="1"]');
        if (giftProduct) {
          var giftLink = e.target.closest('a');
          if (giftLink && giftProduct.contains(giftLink)) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return;
          }
        }

        // Fallback: gift row not marked yet — detect via cart cache
        var product = e.target.closest('.ajaxcart__product');
        if (product && !giftProduct) {
          var keyEl = product.querySelector('.ajaxcart__qty-num[data-id], .ajaxcart__qty-adjust[data-id]');
          var itemFromRow = keyEl ? findItemByKey(keyEl.getAttribute('data-id')) : null;
          if (itemFromRow && isGift(itemFromRow)) {
            var maybeLink = e.target.closest('a');
            if (maybeLink && product.contains(maybeLink)) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              lockGiftQtyControls();
              return;
            }
          }
        }

        var btn = e.target.closest('.ajaxcart__qty-adjust');
        if (!btn) return;
        var key = btn.getAttribute('data-id');
        var line = btn.getAttribute('data-line');
        var item = findItemByKey(key) || findItemByLine(line);
        if (!item || !isGift(item)) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      },
      true
    );

    document.addEventListener(
      'change',
      function (e) {
        var input = e.target;
        if (
          !input ||
          (!input.classList.contains('ajaxcart__qty-num') &&
            !input.classList.contains('cart__product-qty'))
        ) {
          return;
        }
        var item =
          findItemByKey(input.getAttribute('data-id')) ||
          findItemByLine(input.getAttribute('data-line'));
        if (!item) return;

        // Gift: lock — revert typed value
        if (isGift(item)) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          input.value = String(item.quantity);
          return;
        }

        // Main on cart page: keep gift hidden/display qty in sync before form submit
        var newQty = parseInt(input.value, 10);
        if (isNaN(newQty) || newQty < 0) return;
        var items = (cachedCart && cachedCart.items) || [];
        giftsForVariant(items, item.variant_id).forEach(function (gift) {
          var span = document.querySelector('.cart__product-qty--gift[data-id="' + gift.key + '"]');
          if (span) span.textContent = String(newQty);
          var hidden = document.querySelector(
            'input[type="hidden"][name="updates[]"][data-id="' + gift.key + '"]'
          );
          if (hidden) hidden.value = String(newQty);
        });
      },
      true
    );
  }

  function patchShopifyAPI(attempt) {
    if (!window.ShopifyAPI || typeof window.ShopifyAPI.changeItem !== 'function') {
      if (attempt < 60) {
        setTimeout(function () {
          patchShopifyAPI(attempt + 1);
        }, 100);
      }
      return;
    }
    if (window.ShopifyAPI.__ewPatchedV11) return;

    originalChangeItem = window.ShopifyAPI.changeItem;
    if (typeof window.ShopifyAPI.getCart === 'function') {
      originalGetCart = window.ShopifyAPI.getCart;
      window.ShopifyAPI.getCart = function (callback) {
        return originalGetCart.call(this, function (cart) {
          // Clone BEFORE buildCart mutates/strips underscore properties
          cacheCart(cart);
          if (typeof callback === 'function') callback(cart);
          scheduleLockGiftQty();
        });
      };
    }

    window.ShopifyAPI.changeItem = function (line, quantity, callback) {
      var qty = parseInt(quantity, 10);

      // Always resolve against a fresh cart so gift markers / line order are correct
      var run = function (cart) {
        cacheCart(cart);
        var item = findItemByLine(line);
        // Also try DOM key if line map is off
        if (!item) {
          var row = document.querySelector('.ajaxcart__row[data-line="' + parseInt(line, 10) + '"]');
          var keyEl = row && row.querySelector('[data-id]');
          if (keyEl) item = findItemByKey(keyEl.getAttribute('data-id'));
        }

        if (!selfRemoving && item && isGift(item)) {
          return rejectGiftQtyChange(callback);
        }

        if (qty === 0) {
          return removeLineWithLinkedGifts(line, callback);
        }

        return changeLineWithLinkedGifts(line, qty, callback);
      };

      if (cachedCart && cachedCart.items && cachedCart.items.length) {
        return run(cachedCart);
      }
      return refreshCartFromServer().then(run).catch(function () {
        return originalChangeItem.call(window.ShopifyAPI, line, quantity, callback);
      });
    };
    window.ShopifyAPI.__ewPatchedV11 = true;
  }

  var origFetch = window.fetch && window.fetch.bind(window);
  if (origFetch && !window.__ewFetchPatchedV11) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var p = origFetch(input, init);
      var isCartMutate =
        /\/cart\/(add|change|update|clear)\.js/i.test(String(url)) && /POST|PUT|PATCH/.test(method);
      if (isCartMutate && !selfRemoving) {
        if (window.ExtendWarrantyCart && window.ExtendWarrantyCart._buyNowInFlight) {
          return p;
        }
        p.then(function (res) {
          var clone = res && typeof res.clone === 'function' ? res.clone() : null;
          if (!clone) {
            schedule(30);
            return;
          }
          clone
            .json()
            .then(function (cart) {
              if (cart && cart.items) {
                cacheCart(cart);
                scheduleLockGiftQty();
                return syncFromCart(cart);
              }
              schedule(30);
            })
            .catch(function () {
              schedule(30);
            });
        }).catch(function () {});
      }
      return p;
    };
    window.__ewFetchPatchedV11 = true;
  }

  // Re-lock after drawer DOM redraws
  var cartContainer = document.getElementById('CartContainer');
  if (cartContainer && window.MutationObserver) {
    var mo = new MutationObserver(function () {
      scheduleLockGiftQty();
    });
    mo.observe(cartContainer, { childList: true, subtree: true });
  }

  document.addEventListener('cart:updated', function () {
    schedule(30);
    scheduleLockGiftQty();
  });

  patchShopifyAPI(0);
  bindCheckoutGuard();
  bindGiftQtyUiGuard();
  setTimeout(function () {
    refreshCartFromServer().then(syncFromCart);
  }, 200);

  window.ExtendWarrantyCart = {
    __v11: true,
    sync: sync,
    syncFromCart: syncFromCart,
    lockGiftQtyControls: lockGiftQtyControls,
    getCachedCart: function () {
      return cachedCart;
    }
  };
})();
